module.exports = __webpack_public_path__ + "static/img/info1.5a8bc7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info1.png
// module id = SEBG
// module chunks = 0